// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B6sJfDSA174p_u1ll1oh{padding:12px;font-size:13px;font-weight:400;line-height:20px}.B6sJfDSA174p_u1ll1oh.z6o5mI0gsH4Marcgfzb_,.B6sJfDSA174p_u1ll1oh.Hre6gQQMQbgochSw4Ja7{margin-bottom:4px}.B6sJfDSA174p_u1ll1oh.ydVDcNsorCg1AbTQlqXk{cursor:auto}.NOcYP_FnoikZFZ5Yj6tK{margin-top:20px;margin-bottom:4px}.NOcYP_FnoikZFZ5Yj6tK.Gv8ztN7Hj9Uo3U2jnQdo{margin-top:0}.PklxcndnulQbl6NEq23d{align-items:center;gap:8px;display:flex}.PklxcndnulQbl6NEq23d .iNmsWVq6s0_7kEbVMj2n{background-color:var(--border-neutral-primary);width:1px;height:16px}.PklxcndnulQbl6NEq23d .qO5a3CYYUlJa39GyMBac{padding:0;font-size:14px;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textField": `B6sJfDSA174p_u1ll1oh`,
	"warning": `z6o5mI0gsH4Marcgfzb_`,
	"error": `Hre6gQQMQbgochSw4Ja7`,
	"disabled": `ydVDcNsorCg1AbTQlqXk`,
	"inputLabel": `NOcYP_FnoikZFZ5Yj6tK`,
	"noMarginTop": `Gv8ztN7Hj9Uo3U2jnQdo`,
	"leftContentNumber": `PklxcndnulQbl6NEq23d`,
	"verticalDivider": `iNmsWVq6s0_7kEbVMj2n`,
	"countryPicker": `qO5a3CYYUlJa39GyMBac`
};
export default ___CSS_LOADER_EXPORT___;
